import styled from 'styled-components';

//-----------------------------------------------------------------------------
// shared entry styles (used by SiteEntry and VisualEditEntry)
//-----------------------------------------------------------------------------
interface BaseProps {
	active: boolean;
	disabled: boolean;
}

export const Base = styled.div<BaseProps>`
	align-self: flex-start;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	width: calc(100% - 28px);
	border-radius: 12px;
	padding: 8px 12px;
	margin: 4px 0;
	background-color: ${({ theme, active }) => (active ? theme.gray[200] : `transparent`)};
	border-color: ${({ theme, active }) => (active ? theme.gray[400] : theme.gray[200])};
	&:hover {
		background-color: ${({ theme, active, disabled }) =>
			active && !disabled ? theme.gray[200] : 'transparent'};
	}
`;

export const Spacer = styled.div`
	flex: 1;
`;

export const Icon = styled.div`
	margin-top: 2px;
	margin-bottom: -2px;
`;

export const Label = styled.div`
	padding-top: 2px;
	font-size: 14px;
	color: ${({ theme }) => theme.gray[800]};
`;

export const SubLabel = styled.div`
	padding-top: 4px;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const LabelHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const LabelDetails = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const TrashIcon = styled.div<{ isHovered: boolean }>`
	margin-top: 2px;
	margin-bottom: -2px;
	margin-right: 4px;
	opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
	transition: opacity 0.2s;
	cursor: pointer;
`;
